import { render, staticRenderFns } from "./FeatureComparison.vue?vue&type=template&id=9f975496&scoped=true&lang=pug"
var script = {}
import style0 from "./FeatureComparison.vue?vue&type=style&index=0&id=9f975496&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f975496",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9f975496')) {
      api.createRecord('9f975496', component.options)
    } else {
      api.reload('9f975496', component.options)
    }
    module.hot.accept("./FeatureComparison.vue?vue&type=template&id=9f975496&scoped=true&lang=pug", function () {
      api.rerender('9f975496', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/event/anniversary2023/components/FeatureComparison.vue"
export default component.exports